import React, { memo } from "react"
import _ from "lodash"
import { Link } from "react-router-dom"

import MenuItem from "./MenuItem"
import { LoaderMedium } from "../../Loaders"

// hooks
import useMenuItems from "./hooks/useMenuItems"

function StaffMenu() {
  const [loading, items] = useMenuItems("staff")
  if (loading) return <LoaderMedium />

  return (
    <div className="navbar-participants">
      <ul className="first-level">
        {_.map(items, (firstLevel, i) => {
          const { label, path, icon, items } = firstLevel
          const hasSubMenu = !_.isEmpty(items)
          if (hasSubMenu) {
            return (
              <li key={i}>
                <a href="#">
                  <span className="material-icons">{icon}</span>
                  {label}
                  <span className="material-icons right-arrow">
                    chevron_right
                  </span>
                </a>
                <ul className="second-level">
                  {_.map(items, (secondLevel, i) => (
                    <li key={`second-level-${i}`}>
                      <Link to={secondLevel.path}>{secondLevel.label}</Link>
                    </li>
                  ))}
                </ul>
              </li>
            )
          }
          return <MenuItem key={i} path={path} icon={icon} label={label} />
        })}
      </ul>
    </div>
  )
}

export default memo(StaffMenu)
